/*
 * File: d:\projects\AutoFiFront\src\Content\Filter\TextFilterSelector\FilterSelector.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Wednesday February 22nd 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Wednesday February 22nd 2023 1:44:32 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import Filter from "Content/Filters/TextFilter/TextFilters/TextFilters";
import FilterSelected from "Content/Filters/TextFilter/TextFilterSelected/TextFilterSelected";
import React, { MouseEventHandler } from "react";

type FilterSelectorProps = {
    selected : boolean,
    selectedValue: string,
    selectData: {label: string, value:string}[],
    functionSet: React.ChangeEventHandler<HTMLSelectElement>,
    functionReset: MouseEventHandler<SVGElement>,
    asFollower: boolean,
    themeColor: string
};

function FilterSelector(props: FilterSelectorProps) {
    return(
        <React.Fragment>
            {props.selected ?
            <FilterSelected selected={props.selectedValue} function={props.functionReset} themeColor={props.themeColor} asFollower={props.asFollower} /> :
            <Filter themeColor={props.themeColor} selectable={props.selectData} selectFunc={props.functionSet} icon={undefined} />
            }
        </React.Fragment>
    );
}
export default FilterSelector;
